import parseStringToHTML from "html-react-parser";
import { ToolTipPosition } from "../utilities/frontendTypes";
import {
  Tooltip as RadixTooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "./ui/tooltip";
import { faCircleInfo, faLock } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

/** Maps old position prop to Radix `side` + `align` */
const positionToSide = (position?: ToolTipPosition) => {
  switch (position) {
    case "top-left":
      return { side: "left" as const, align: "end" as const };
    case "bottom-left":
      return { side: "left" as const, align: "start" as const };
    case "top-right":
      return { side: "right" as const, align: "end" as const };
    case "bottom-right":
    default:
      return { side: "right" as const, align: "start" as const };
  }
};

function Tooltip({
  content,
  type,
  position,
  customWidth,
}: {
  content: string;
  type?: "lock";
  position?: ToolTipPosition;
  customWidth?: string;
}) {
  const { side, align } = positionToSide(position);
  const isLock = type === "lock";

  return (
    <TooltipProvider delayDuration={200}>
      <RadixTooltip>
        <TooltipTrigger asChild>
          <button
            type="button"
            tabIndex={0}
            className={`tooltipIcon relative ml-3 ${isLock ? "flex items-center" : "inline-block"}`}
          >
            {isLock ? (
              <FontAwesomeIcon icon={faLock} className="z-20 text-text/70" />
            ) : (
              <FontAwesomeIcon icon={faCircleInfo} className="text-muted-foreground w-[17px] h-[17px]" />
            )}
          </button>
        </TooltipTrigger>
        <TooltipContent
          side={side}
          align={align}
          className={`break-words min-w-[150px] max-w-[300px] ${customWidth || ""}`}
        >
          <span>{parseStringToHTML(content)}</span>
        </TooltipContent>
      </RadixTooltip>
    </TooltipProvider>
  );
}

export default Tooltip;
